/**
 * The platform's `SchedulerRuntime` — the shared scheduler panes' I/O, over
 * this app's own `/api/schedules/*` endpoints.
 *
 * The downloaded runtime supplies its own against `/app/{project}/api/…`.
 * Neither knows about the other; the panes know about neither.
 */
import toast from 'react-hot-toast'
import type { SchedulerRuntime } from '@twasta/page-runtime/shell/jobs'
import {
  getRun, getSchedule, listRuns, runNow, runOutputUrl,
} from '@/api/schedules'

export function makeSchedulerRuntime(
  project: string, opts: { canRun?: boolean } = {},
): SchedulerRuntime {
  const canRun = opts.canRun !== false
  return {
    get: async (name) => (await getSchedule(project, name)).schedule,
    listRuns: async (o) => (await listRuns(project, o)).runs || [],
    getRun: async (runId) => (await getRun(project, runId)).run,
    ...(canRun ? { runNow: (name: string) => runNow(project, name) } : {}),
    outputUrl: (runId, filename) => runOutputUrl(project, runId, filename),
    notify: (kind, message) => {
      if (kind === 'success') toast.success(message)
      else toast.error(message)
    },
  }
}
